module.exports = __webpack_public_path__ + "static/roadside-breakdown-trucking-f01c0d1fee32af0213b53609adce7da6.svg";